import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function LinkRow({ label, links = EMPTY_ARRAY }) {
  // Every group is built server-side with a canonical category_url. A link without one has no
  // usable href here - the page's own base URL is /preview-search/..., which resolves to no
  // listing path - so drop it rather than mint a broken link.
  const linksWithUrl = links.filter(link => link.categoryUrl)

  if (linksWithUrl.length === 0) {
    return null
  }

  return (
    <div className="seo-link-row">
      <span className="seo-link-row__label cgt-body-base-semibold">{label}</span>
      <ul className="seo-link-row__links">
        {linksWithUrl.map(link => (
          <li className="seo-link-row__item" key={link.categoryUrl}>
            {/* ValidBrowseByTypeUrls labels its entries with `tag`; every other group uses `key`. */}
            <a className="seo-link-row__link cgt-link-primary-accented" href={link.categoryUrl}>
              {link.key || link.tag}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

LinkRow.propTypes = {
  label: string.isRequired,
  links: arrayOf(shape({
    key: string,
    tag: string,
    categoryUrl: string,
  })),
}

export default LinkRow
